import { render, staticRenderFns } from "./BaseFichaDatos.vue?vue&type=template&id=c5db5af6&scoped=true"
import script from "./BaseFichaDatos.vue?vue&type=script&lang=js"
export * from "./BaseFichaDatos.vue?vue&type=script&lang=js"
import style0 from "./BaseFichaDatos.vue?vue&type=style&index=0&id=c5db5af6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5db5af6",
  null
  
)

export default component.exports